import React, { useState } from "react";
import styled from "styled-components";
import { Row, Col, Card } from "react-bootstrap";
import DetailSection from "./DetailSection";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { VentaResumida } from "../../../services/ventasServicios";
import TableSection from "./TableSection";

function MasterDetailSection({
  items,
  resetTable,
}: {
  items: VentaResumida[];
  resetTable: () => void;
}) {
  const [animationParent] = useAutoAnimate<HTMLDivElement>();

  const [ventaSeleccionada, setVentaSeleccionada] = useState<
    VentaResumida | undefined
  >(undefined);

  const onVentaSeleccionada = (venta: VentaResumida) => {
    setVentaSeleccionada(venta);
  };

  const onCerrarDetailClick = () => {
    setVentaSeleccionada(undefined);
  };

  const onRegistrarPago = () => {
    resetTable();
    setVentaSeleccionada(undefined);
  };

  return (
    <StyledRow>
      <Col sm="10" xxl="8">
        <StyledCard>
          <StyledCardBody>
            <Row ref={animationParent}>
              {!ventaSeleccionada && (
                <Col sm="12">
                  <TableSection
                    items={items}
                    onVentaSeleccionada={onVentaSeleccionada}
                  />
                </Col>
              )}

              {ventaSeleccionada && (
                <DetailSection
                  idVenta={ventaSeleccionada.id}
                  onPagoFinalizado={onRegistrarPago}
                  onCloseClick={onCerrarDetailClick}
                />
              )}
            </Row>
          </StyledCardBody>
        </StyledCard>
      </Col>
    </StyledRow>
  );
}

const StyledRow = styled(Row)`
  justify-content: center;
`;

const StyledCard = styled(Card)`
  margin-bottom: 1.875rem;
  background-color: #fff;
  transition: all 0.5s ease-in-out;
  position: relative;
  border: 0px solid transparent;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 13px 0px rgb(82 63 105 / 5%);
`;

const StyledCardBody = styled(Card.Body)`
  padding: 1.25rem;
`;

export default MasterDetailSection;
